// extracted by mini-css-extract-plugin
export default {"statusPanel":"SoloStatusWide_statusPanel__yS2WB","statusItem":"SoloStatusWide_statusItem__QS9pW","label":"SoloStatusWide_label__N4sk5","value":"SoloStatusWide_value__v6Mt2"};